module.exports = __webpack_public_path__ + "static/media/hoppygo.1d7f198d.jpg";